import React from 'react';
import { Table, Empty } from 'antd';
import DetalladoMovimientoTable from './DetalladoMovimientoTable';

export default class DetalladoProductoTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return (
            <Table
                className={'logistica-table-kardex-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={true}
                dataSource={this.props.dataSource}
                rowKey={record => record.uid}
                onExpand={async (expanded, record) => {
                    await this.props.onSearchKardexMovimiento(record);
                }}
                expandedRowRender={(record) => {
                    return (
                        <div style={{ margin: '10px 0px' }}>
                            <DetalladoMovimientoTable dataSource={record.movimientos} />
                        </div>
                    )
                }}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='No se encontraron datos.'
                    />
                }}
                columns={[
                    {
                        title: 'Código de Referencia',
                        dataIndex: 'codigoReferencia',
                        key: 'codigoReferencia',
                        sorter: true
                    },
                    {
                        title: 'Producto',
                        dataIndex: 'nombre',
                        key: 'nombre'
                    },
                    {
                        title: 'Lote',
                        dataIndex: 'lote',
                        key: 'lote',
                        sorter: true
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'unidadMedida',
                        className: 'child-group',
                        key: 'unidadMedida'
                    },
                    {
                        title: 'Cantidades',
                        className: 'parent-group',
                        children: [
                            {
                                title: 'Saldo Inicial',
                                dataIndex: 'saldoInicialCantidad',
                                key: 'saldoInicialCantidad',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Ingresos',
                                dataIndex: 'ingresoCantidad',
                                key: 'ingresoCantidad',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Salidas',
                                dataIndex: 'salidaCantidad',
                                key: 'salidaCantidad',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Saldo Final',
                                dataIndex: 'saldoFinalCantidad',
                                key: 'saldoFinalCantidad',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            }
                        ]
                    },
                    {
                        title: 'Montos',
                        className: 'parent-group',
                        children: [
                            {
                                title: 'Saldo Inicial',
                                dataIndex: 'saldoInicialMonto',
                                key: 'saldoInicialMonto',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Ingresos',
                                dataIndex: 'ingresoMonto',
                                key: 'ingresoMonto',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Salidas',
                                dataIndex: 'salidaMonto',
                                key: 'salidaMonto',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Saldo Final',
                                dataIndex: 'saldoFinalMonto',
                                key: 'saldoFinalMonto',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            }
                        ]
                    },
                    {
                        title: 'Precio Promedio',
                        dataIndex: 'precioPromedio',
                        key: 'precioPromedio',
                        className: 'child-group',
                        align: 'right',
                        render: (data) => (
                            <span>{data.toFixed(3)}</span>
                        )
                    },
                ]}
            />
        );
    }
}